import React, { useState, useRef, useEffect } from 'react'
import styles from './index.module.less'
import ArrowPng from '@/assets/arrow.png'
import { Tooltip } from 'antd'
interface IProps {
  items: any[]
  onlyImg?: boolean
  imgWidth?: number
  getValue?: (item: any) => void // 获取选中的值
  showValue?: any // 回显
}
export default function HorizontalScrollGallery(props: IProps) {
  const { items, onlyImg = false, imgWidth, getValue, showValue } = props
  const [showLeftButton, setShowLeftButton] = useState(false)
  const [showRightButton, setShowRightButton] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const containerRef = useRef<any>(null)
  const contentRef = useRef<any>(null)
  useEffect(() => {
    if (showValue) {
      const index = items.findIndex(item => item?.category?.id === showValue)
      setCurrentIndex(index)
      getValue?.(items[index])
    }

    // }
  }, [showValue, items])
  // 检测是否需要显示滚动按钮
  const checkScroll = () => {
    if (containerRef.current && contentRef.current) {
      const container: any = containerRef.current
      const isAtStart = container.scrollLeft === 0
      const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1

      setShowLeftButton(!isAtStart)
      setShowRightButton(!isAtEnd)
    }
  }

  useEffect(() => {
    checkScroll()
    const container: any = containerRef.current
    container?.addEventListener('scroll', checkScroll)
    window.addEventListener('resize', checkScroll)

    return () => {
      container?.removeEventListener('scroll', checkScroll)
      window.removeEventListener('resize', checkScroll)
    }
  }, [items])

  // 滚动到右侧
  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: 400,
        behavior: 'smooth',
      })
    }
  }

  // 滚动到左侧
  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: -400,
        behavior: 'smooth',
      })
    }
  }
  const handleClick = (item: any, index: number) => {
    setCurrentIndex(index)
    getValue?.(item)
  }
  return (
    <div className={styles.scrollBox}>
      {/* 左侧滚动按钮 */}
      {showLeftButton && (
        <div onClick={scrollLeft} className={`${styles.scrollButton} ${styles.scrollButtonLeft}`}>
          <img src={ArrowPng} alt="" />
        </div>
      )}

      {/* 滚动容器 */}
      <div ref={containerRef} className={styles.scrollOuterBox}>
        <div ref={contentRef} className={styles.scrollInnerBox}>
          {onlyImg ? (
            <>
              {items?.map((item, index) => (
                <div
                  key={index}
                  className={`${styles.scrollItemOnlyImg} ${currentIndex === index ? styles.scrollItemActive : ''}`}
                  onClick={() => handleClick(item, index)}
                >
                  <img src={item}  style={{width: imgWidth, height: imgWidth}} alt="" />
                </div>
              ))}
            </>
          ) : (
            items?.map((item, index) => (
              <div
                key={index}
                className={`${styles.scrollItem} ${currentIndex === index ? styles.scrollItemActive : ''}`}
                // onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.01)')}
                // onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
                onClick={() => handleClick(item, index)}
              >
                <img
                  src={item?.imgSrc || 'https://static.shjmall.cn/sass/empty.png'}
                  width={imgWidth}
                  alt=""
                />
                <Tooltip title={item?.title}>
                  <div className={styles.scrollItemTitle}>{item?.title}</div>
                </Tooltip>
              </div>
            ))
          )}
        </div>
      </div>

      {/* 右侧滚动按钮 */}
      {showRightButton && (
        <div onClick={scrollRight} className={`${styles.scrollButton} ${styles.scrollButtonRight}`}>
          <img src={ArrowPng} width={16} alt="" />
        </div>
      )}
    </div>
  )
}
